import { AxiosRequestConfig } from 'axios';

import { StudentInAssignmentProgress } from '../../../../sdk/src/shared';
import { BASE_API } from '../../utils';

interface Student {
  id: string;
  firstName: string;
  lastName: string;
  username: string;
}

interface StudentInClass {
  classId: string;
  isInIndividualMixedReview: boolean;
  studentInClassId: string;
}

export interface StudentDataStudentInKlassAssignmentsItem
  extends StudentInAssignmentProgress {
  assignedAt: string;
  pointsRequiredTotal: number;
  pointsRequiredNewSkills: number;
  pointsRequiredSpiralReview: number;
  name: string;
}

export interface StudentDataStudentInKlassAssignmentsResponse {
  classAssignments: StudentDataStudentInKlassAssignmentsItem[];
  student: Student;
  studentInClass: StudentInClass;
}

interface AssignmentsConfig extends AxiosRequestConfig {
  method: 'GET';
  url: `/student-in-classes/${string}/assignments`;
}

export const assignments = (studentInClassId: string): AssignmentsConfig => ({
  baseURL: BASE_API,
  method: 'GET',
  url: `/student-in-classes/${studentInClassId}/assignments`,
});
